import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SmallLoader from "@shared/components/Atoms/Loading/SmallLoading";
import axios from "axios";
import { APP_NAME } from "@shared/util/brand";
import { BRAND } from "@shared/brand";
import CondenseLogo from "@shared/components/Atoms/CondenseLogo";
import NewzAgentLogo from "@shared/components/Atoms/NewzAgentLogo";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const [step, setStep] = useState(1);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);

  const validatePassword = (pwd, confirm) => {
    const errors = [];
    if (pwd !== confirm) errors.push("Passwords do not match.");
    if (pwd.length < 3) errors.push("Password must be at least 3 characters long.");
    return { isValid: errors.length === 0, errors };
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    try {
      setError([]);
      const ers = validatePassword(newPassword, confirmPassword);
      if (!ers.isValid) {
        setError(ers.errors);
        return;
      }
      setLoading(true);
      const button = document.querySelector("#reset_btn");
      if (button) {
        button.textContent = "Updating Password ...";
        button.disabled = true;
      }
      const res = await axios.post(`${import.meta.env.VITE_API_URL}/auth/reset-password`, {
        email,
        token,
        password: newPassword,
      });
      if (res?.data) setStep(2);
    } catch (err) {
      console.error(err);
      setError([
        err?.response?.data?.msg ||
          err?.response?.data?.error ||
          "An error occurred. Please try again.",
      ]);
    } finally {
      setLoading(false);
      const button2 = document.querySelector("#reset_btn");
      if (button2) {
        button2.textContent = "Update Password";
        button2.disabled = false;
      }
    }
  };

  if (BRAND.id === "condense") {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
          .cd-auth {
            min-height: 100vh; background-color: #11141B;
            display: flex; align-items: center; justify-content: center;
            position: relative; overflow: hidden; font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            padding: 24px 16px;
          }
          .cd-auth-glow {
            position: absolute; top: -15%; left: 50%; transform: translateX(-50%); width: 900px; height: 500px;
            background: radial-gradient(ellipse, rgba(24, 216, 137, 0.1) 0%, transparent 70%); filter: blur(70px); pointer-events: none;
          }
          .cd-auth-card {
            position: relative; z-index: 1; width: 100%; max-width: 420px; padding: 40px 32px 36px;
            background: #1C2029; border: 1px solid rgba(245,247,248,0.10); border-radius: 16px;
            box-shadow: 0 20px 60px -20px rgba(0,0,0,.5); text-align: center;
          }
          .cd-auth-logo { display: flex; justify-content: center; margin-bottom: 28px; }
          .cd-auth-card h1 { margin: 0 0 8px; font-size: 22px; font-weight: 600; color: #F5F7F8; }
          .cd-auth-card p { margin: 0 0 20px; font-size: 14px; color: #929AA7; line-height: 1.5; }
          .cd-auth-card label { display: block; text-align: left; margin-bottom: 6px; font-size: 14px; font-weight: 500; color: #929AA7; }
          .cd-auth-card input {
            width: 100%; padding: 14px 16px; background: #11141B; border: 1px solid rgba(245,247,248,0.10);
            border-radius: 10px; color: #F5F7F8; font-size: 15px; font-family: Inter, sans-serif; text-transform: none; letter-spacing: 0; outline: none; box-sizing: border-box;
          }
          .cd-auth-card input:focus { border-color: rgba(24, 216, 137, 0.7); }
          .cd-auth-field { margin-bottom: 16px; text-align: left; }
          .cd-auth-error {
            background: rgba(220,38,38,0.15); border: 1px solid rgba(220,38,38,0.3); color: #fca5a5;
            padding: 10px 14px; border-radius: 10px; font-size: 14px; margin-bottom: 10px; text-align: left;
          }
          .cd-auth-btn {
            width: 100%; padding: 14px; background: #18D889; color: #11141B; font-size: 16px; font-weight: 600;
            border: none; border-radius: 10px; cursor: pointer;
          }
          .cd-auth-btn:hover { background: #14c47a; }
          .cd-auth-btn-outline {
            width: 100%; padding: 12px; background: transparent; color: #52F2AE; font-size: 15px; font-weight: 600;
            border: 1px solid rgba(24, 216, 137, 0.5); border-radius: 10px; cursor: pointer; text-decoration: none; display: inline-block;
          }
          .cd-auth-btn-outline:hover { background: rgba(24, 216, 137, 0.12); }
          .cd-auth-success {
            width: 64px; height: 64px; margin: 0 auto 20px; border-radius: 9999px; background: #18D889; color: #11141B;
            display: flex; align-items: center; justify-content: center; font-size: 28px;
          }
        `}</style>
        <div className="cd-auth">
          <div className="cd-auth-glow" />
          <div className="cd-auth-card">
            <div className="cd-auth-logo">
              <Link to="/">
                <CondenseLogo height={28} color="#F5F7F8" />
              </Link>
            </div>
            {step === 1 && (
              <>
                <h1>Reset Password</h1>
                <p>Create a new password for your account</p>
                <form onSubmit={handleResetSubmit}>
                  <div className="cd-auth-field">
                    <label htmlFor="new-password">New Password</label>
                    <input
                      id="new-password"
                      type="password"
                      placeholder="••••••••"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="cd-auth-field">
                    <label htmlFor="confirm-password">Confirm Password</label>
                    <input
                      id="confirm-password"
                      type="password"
                      placeholder="••••••••"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                  {error.map((k, i) => (
                    <div key={i} className="cd-auth-error">
                      {k}
                    </div>
                  ))}
                  {loading && (
                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
                      <SmallLoader />
                    </div>
                  )}
                  <button type="submit" id="reset_btn" className="cd-auth-btn">
                    Update Password
                  </button>
                </form>
              </>
            )}
            {step === 2 && (
              <>
                <div className="cd-auth-success">✓</div>
                <h1>Password Updated!</h1>
                <p>You can now sign in to your {APP_NAME} account with your new password.</p>
                {/* Full page load: /login is served by the app SPA (.htaccess), not public routes */}
                <a href="/login" className="cd-auth-btn-outline">
                  Sign In Now
                </a>
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  if (BRAND.id === "newzagent") {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Montserrat:wght@700;900&display=swap');
          .nz-auth {
            min-height: 100vh; background: #020617; display: flex; align-items: center; justify-content: center;
            position: relative; overflow: hidden; font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            padding: 24px 16px;
          }
          .nz-auth-glow {
            position: absolute; top: -15%; left: 50%; transform: translateX(-50%); width: 900px; height: 500px;
            background: radial-gradient(ellipse, rgba(127,29,29,0.35) 0%, transparent 70%); filter: blur(100px); pointer-events: none;
          }
          .nz-auth-card {
            position: relative; z-index: 1; width: 100%; max-width: 420px; padding: 40px 32px 36px;
            background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.10); border-radius: 20px;
            box-shadow: 0 20px 60px -20px rgba(0,0,0,.6); text-align: center;
          }
          .nz-auth-logo { display: flex; justify-content: center; margin-bottom: 28px; }
          .nz-auth-card h1 { margin: 0 0 8px; font-size: 22px; font-weight: 600; color: #f8fafc; }
          .nz-auth-card p { margin: 0 0 20px; font-size: 14px; color: #94a3b8; line-height: 1.5; }
          .nz-auth-card label { display: block; text-align: left; margin-bottom: 6px; font-size: 14px; font-weight: 500; color: #cbd5e1; }
          .nz-auth-card input {
            width: 100%; padding: 14px 16px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.10);
            border-radius: 12px; color: #f8fafc; font-size: 15px; font-family: inherit; outline: none; box-sizing: border-box;
          }
          .nz-auth-card input:focus { border-color: rgba(220,38,38,0.6); }
          .nz-auth-field { margin-bottom: 16px; text-align: left; }
          .nz-auth-error {
            background: rgba(220,38,38,0.15); border: 1px solid rgba(220,38,38,0.3); color: #fca5a5;
            padding: 10px 14px; border-radius: 10px; font-size: 14px; margin-bottom: 10px; text-align: left;
          }
          .nz-auth-btn {
            width: 100%; padding: 14px; background: #dc2626; color: #fff; font-family: 'Montserrat', sans-serif;
            font-size: 16px; font-weight: 700; border: none; border-radius: 12px; cursor: pointer;
          }
          .nz-auth-btn-outline {
            width: 100%; padding: 12px; background: transparent; color: #fca5a5; font-size: 15px; font-weight: 600;
            border: 1px solid rgba(220,38,38,0.5); border-radius: 12px; cursor: pointer; text-decoration: none; display: inline-block;
          }
          .nz-auth-success {
            width: 64px; height: 64px; margin: 0 auto 20px; border-radius: 9999px; background: #dc2626; color: #fff;
            display: flex; align-items: center; justify-content: center; font-size: 28px;
          }
        `}</style>
        <div className="nz-auth">
          <div className="nz-auth-glow" />
          <div className="nz-auth-card">
            <div className="nz-auth-logo">
              <Link to="/">
                <NewzAgentLogo height={40} color="#ffffff" accentColor="#ef4444" />
              </Link>
            </div>
            {step === 1 && (
              <>
                <h1>Reset Password</h1>
                <p>Create a new password for your account</p>
                <form onSubmit={handleResetSubmit}>
                  <div className="nz-auth-field">
                    <label htmlFor="new-password">New Password</label>
                    <input
                      id="new-password"
                      type="password"
                      placeholder="••••••••"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="nz-auth-field">
                    <label htmlFor="confirm-password">Confirm Password</label>
                    <input
                      id="confirm-password"
                      type="password"
                      placeholder="••••••••"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                  {error.map((k, i) => (
                    <div key={i} className="nz-auth-error">
                      {k}
                    </div>
                  ))}
                  {loading && (
                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
                      <SmallLoader />
                    </div>
                  )}
                  <button type="submit" id="reset_btn" className="nz-auth-btn">
                    Update Password
                  </button>
                </form>
              </>
            )}
            {step === 2 && (
              <>
                <div className="nz-auth-success">✓</div>
                <h1>Password Updated!</h1>
                <p>You can now sign in with your new password.</p>
                <a href="/login" className="nz-auth-btn-outline">
                  Sign In Now
                </a>
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-br from-[#2563EB] via-[#1D4ED8] to-[#1E3A8A] p-5">
      <div className="text-white text-3xl font-semibold mt-5 mb-10">{APP_NAME}</div>
      <div className="bg-white rounded-2xl p-10 w-full max-w-md shadow-xl text-center">
        {step === 1 && (
          <div>
            <h1 className="text-2xl font-semibold text-[#1E3A8A] mb-2">Reset Password</h1>
            <p className="text-gray-600 mb-6">Create a new password for your account</p>
            <form onSubmit={handleResetSubmit} className="text-left">
              <label className="block text-[#1E3A8A] font-medium mb-2">New Password</label>
              <input
                type="password"
                className="w-full p-4 rounded-xl bg-gray-100 border-2 border-gray-200 focus:border-blue-500 focus:bg-white transition mb-4"
                placeholder="••••••••"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <label className="block text-[#1E3A8A] font-medium mb-2">Confirm Password</label>
              <input
                type="password"
                className="w-full p-4 rounded-xl bg-gray-100 border-2 border-gray-200 focus:border-blue-500 focus:bg-white transition mb-4"
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <div className="my-4">
                {error.map((k, i) => (
                  <div key={i} className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm mb-2">
                    {k}
                  </div>
                ))}
                {loading && <SmallLoader />}
              </div>
              <button
                type="submit"
                id="reset_btn"
                className="w-full py-4 bg-gradient-to-br from-[#2563EB] via-[#1D4ED8] to-[#1E3A8A] text-white font-semibold rounded-xl hover:shadow-lg transition mb-4"
              >
                Update Password
              </button>
            </form>
          </div>
        )}
        {step === 2 && (
          <div>
            <div className="w-20 h-20 mx-auto rounded-full bg-green-600 text-white flex items-center justify-center text-3xl mb-6">
              ✓
            </div>
            <h1 className="text-2xl font-semibold text-[#1E3A8A] mb-2">Password Updated!</h1>
            <p className="text-gray-600 mb-6">
              You can now sign in to your {APP_NAME} account with your new password.
            </p>
            <a
              href="/login"
              className="w-full inline-block py-3 border-2 border-[#1E3A8A] text-[#1E3A8A] font-medium rounded-xl hover:bg-[#1E3A8A] hover:text-white transition"
            >
              Sign In Now
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
